import { CandidateAssignmentsTable } from '@/features/recruitment/components/candidate-assignments-table';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/recruitment/candidates_/$id/vacancies')({
  component: VacanciesTab,
});

function VacanciesTab() {
  const { id } = Route.useParams();
  return <CandidateAssignmentsTable candidateId={id} />;
}
